/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { memo, useState, useEffect } from 'react';

// import Swiper core and required modules

import { listingLike } from '../../../store/feature/listingSlice';

import { check_login } from '../../../constant/check_auth';
import { Home_page_text } from '../../../constant/Translation/Home';
import ListingsCarouselSkeleton from '../../Shared/skeletonUI/Listing/ListingsCarouselSkeleton';
import {
  homePageSectionOptimisticUpdate,
  homePageSelector,
  setError,
} from '../../../store/feature/Pages/Home/homePageSlice';
import { get_dynamic_styles } from '../../../constant/DynamicStyles';
import ListingsCarousel from '../../Listings/ListingsCarousel';
import ListingsList from '../../Listings/ListingsList';
import axios from 'axios';
import { useRouter } from 'next/router';
import ListingDynamicSkeleton from '../../Shared/skeletonUI/Listing/ListingDynamicSkeleton';
import { TYPE_CONSTANT } from '../../../constant/Web_constant';
import { useDispatch } from 'react-redux';
// install Swiper modules

const SocialFeedListing = ({ data, styles }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const like = (id, isLiked) => {
    if (check_login(router)) {
      dispatch(
        listingLike({
          id,
          isLiked,
        })
      )
        .then((res) => {
          if (!res.payload.code) {
            fetchListings();
          } else {
            fetchListings();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const fetchListings = () => {
    setIsLoading(true);
    axios
      .get(`/api/a/social_feed?page=1&status=2&per_page=${data?.per_page}`)
      .then((res) => {
        setListings(res.data?.listings);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchListings();
  }, []);

  return (
    <div className=" " style={get_dynamic_styles(styles?.main_styles)}>
      {!isLoading &&
        listings?.length > 0 &&
        (data?.listing_type === 'list' ? (
          <ListingsList Products={listings} like_listing={like} />
        ) : (
          <ListingsCarousel Products={listings} like_listing={like} />
        ))}

      {isLoading && (
        <ListingDynamicSkeleton
          listings_type={data?.listing_type}
          listing_card_type={
            TYPE_CONSTANT.STYLES_CONFIGS?.listing_card?.card_type?.type
          }
        />
      )}
    </div>
  );
};

export default memo(SocialFeedListing);
